import catalogModule from '../catalogModule';

function constantsService(languageResource) {
  'ngInject';

  const ls = languageResource;
  return {
    addGearToGameModal: {
      title: ls.get('Label.Dialog.AddGearTitle'),
      bodyContent: ls.get('Description.Dialog.AddGearBody'),
      declineText: ls.get('Action.Dialog.AddGearOk'),
      cssClass: 'add-gear-modal'
    },
    genreOrText(genre1, genre2) {
      return ls.get('Label.BreadCrumb.GenreOrText', { genreName1: genre1, genreName2: genre2 });
    },
    genreTextSelected(genreCount) {
      return ls.get('Label.BreadCrumb.GenreSelectedText', { genreCount });
    }
  };
}

catalogModule.factory('constantsService', constantsService);

export default constantsService;
